import { WorkFormMode } from '../work-form.types';

export const useWorkFormTexts = (formMode: WorkFormMode) => {
  if (formMode === 'create') {
    return {
      title: 'Nieuwe shift toevoegen',
      subtitle: 'Vul de onderstaande gegevens in',
    };
  } else if (formMode === 'edit') {
    return {
      title: 'Shift aanpassen',
      subtitle: 'Werk de onderstaande gegevens bij',
    };
  } else if (formMode === 'duplicate') {
    return {
      title: 'Shift dupliceren',
      subtitle: 'Vul de onderstaande gegevens in',
    };
  } else {
    throw new Error('Invalid form mode');
  }
};
